import { defineMessages } from 'react-intl';
const i18nKey = 'BusinessesTab';
const messages = defineMessages({
  // Description column
  businessesTitle: {
    id: `${i18nKey}.businessesTitle`,
    defaultMessage: 'Onchain Payment Protocol',
    description: `
    #Component: TextHeadline
    #CharLimit: 80
    #Context: Title for products for Businesses section`
  },
  businessesDescription: {
    id: `${i18nKey}.businessesDescription`,
    defaultMessage: 'A new standard for onchain payments.',
    description: `
    #Component: TextLabel2
    #CharLimit: 130
    #Context: Description of products for Businesses`
  },
  businessesLinkText: {
    id: `${i18nKey}.businessesLinkText`,
    defaultMessage: 'Go to Commerce',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Link to Commerce`
  },
  // Businesses tab
  commerce: {
    id: `${i18nKey}.commerceTitle`,
    defaultMessage: 'Commerce',
    description: `
    #Component: TextHeadline
    #CharLimit: 20
    #Context: Commerce menu item title`
  },
  commerceDescription: {
    id: `${i18nKey}.commerceDescription`,
    defaultMessage: 'Start accepting crypto payments',
    description: `
    #Component: TextLabel2
    #CharLimit: 60
    #Context: Commerce menu item description`
  },
  assetListings: {
    id: `${i18nKey}.assetListings`,
    defaultMessage: 'Asset Listings',
    description: `
    #Component: Link
    #CharLimit: 30
    #Context: Asset Listings menu item title`
  },
  assetListingsDescription: {
    id: `${i18nKey}.assetListingsDescription`,
    defaultMessage: 'List your asset on Coinbase',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Asset Listings menu item description`
  },
  mobileNavBarLinkText: {
    id: `${i18nKey}.mobileNavBarLinkText`,
    defaultMessage: 'See all',
    description: `
    #Component: Button
    #CharLimit: 50
    #Context: Navbar link text for mobile`
  },
  coinbaseBusiness: {
    id: `${i18nKey}.coinbaseBusiness`,
    defaultMessage: 'Business',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Coinbase Business product label`
  },
  coinbaseBusinessDescription: {
    id: `${i18nKey}.coinbaseBusinessDescription`,
    defaultMessage: 'Crypto trading and payments for startups and SMBs',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Coinbase Business product description`
  },
  // link titles
  commerceLinkTitle: {
    id: `${i18nKey}.commerceLinkTitle`,
    defaultMessage: 'Go to Commerce',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Link to Commerce`
  },
  coinbaseBusinessLinkTitle: {
    id: `${i18nKey}.coinbaseBusinessLinkTitle`,
    defaultMessage: 'Coinbase Business - Crypto trading and payments for startups and SMBs',
    description: `
    #Component: Link
    #CharLimit: 110
    #Context: Coinbase Business link title (CharLimit autocalculated to 110)`
  },
  assetListingsLinkTitle: {
    id: `${i18nKey}.assetListingsLinkTitle`,
    defaultMessage: 'Go to Asset Listings',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Link to Asset Listings`
  },
  // Icon alt text
  commerceIconAltText: {
    id: `${i18nKey}.commerceIconAltText`,
    defaultMessage: 'Coinbase Commerce Icon',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Alternative info for Commerce Icon image`
  },
  coinbaseBusinessIconAltText: {
    id: `${i18nKey}.coinbaseBusinessIconAltText`,
    defaultMessage: 'Coinbase Business Icon',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Alternative info for Coinbase Business Icon image`
  },
  assetListingsIconAltText: {
    id: `${i18nKey}.assetListingsIconAltText`,
    defaultMessage: 'Coinbase Asset Listings Icon',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Alternative info for Asset Listings Icon image`
  }
});
export { messages as default };
//# sourceMappingURL=messages.js.map
